import {
  forEach,
  isNumber
} from "lodash"
import pluralize from "pluralize"
import {
  numToWords
} from "../number/numberToWords"

/**
 * Singular -> plural exceptions that don't fit the "bung an 's' on the end" rule.
 * Here are some examples to demonstrate the use.
 *
 * Exceptions keys in the future can become objects which are categorised by locale.
 *
 * @private
 */
const _exceptions = {
  person: "people"
}

const buildExceptions = () => {
  forEach(_exceptions, (value, key) => {
    pluralize.addPluralRule(key, value)
  })
}

/**
 * By default return the provided singular word with
 *
 * @param singular
 * @param count
 * @returns {string}
 */
export default (singular, count, textBeforeNumber) => {
  buildExceptions()
  if (isNumber(textBeforeNumber) && count <= textBeforeNumber) {
    return `${numToWords(count)} ${pluralize(singular, count)}`
  }
  return pluralize(singular, count, !!textBeforeNumber)
}
